import {
  Box,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { PipelineFilterProps } from '../DealsFilters.types';

const CustomDropdownIcon = (props: any) => {
  return (
    <Box
      {...props}
      component='span'
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
      }}
    >
      <img
        src='/assets/down-arrow.svg'
        alt='down arrow'
        style={{
          width: '24px',
          height: '24px',
          display: 'block',
        }}
      />
    </Box>
  );
};

export const PipelineFilter = ({
  selectedPipelines,
  pipelineOptions,
  onChange,
}: PipelineFilterProps) => {
  const isAllSelected =
    pipelineOptions.length > 0 && selectedPipelines.length === pipelineOptions.length;

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const { value } = event.target;
    const lastSelected = value[value.length - 1];

    if (lastSelected === 'all') {
      onChange(selectedPipelines.length === pipelineOptions.length ? [] : [...pipelineOptions]);
      return;
    }

    onChange(typeof value === 'string' ? value.split(',') : value);
  };

  return (
    <FormControl>
      <InputLabel id='pipeline-checkbox-label'>Pipelines</InputLabel>
      <Select
        labelId='pipeline-checkbox-label'
        id='pipeline-checkbox'
        multiple
        value={isAllSelected ? ['All Pipelines'] : selectedPipelines}
        onChange={handleChange}
        renderValue={(selected) => selected.join(', ')}
        sx={{
          width: {xl: '200px', xs: '120px'},
          borderRadius: '50px',
          '@media (max-width: 1699.95px)': {
            borderRadius: '50px',
          },
          '& .MuiSelect-select': {
            paddingLeft: '16px',
            paddingRight: '16px',
          },
          '& .MuiSelect-icon': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            right: '8px',
            top: '50%',
            transform: 'translateY(-50%)',
          },
        }}
        IconComponent={CustomDropdownIcon}
        label={'Pipelines'}
      >
        <MenuItem value='all'>
          <Checkbox
            checked={isAllSelected}
            indeterminate={
              selectedPipelines.length > 0 && selectedPipelines.length < pipelineOptions.length
            }
          />
          <ListItemText primary='All Pipelines' />
        </MenuItem>
        {pipelineOptions.map((name) => (
          <MenuItem key={name} value={name}>
            <Checkbox checked={selectedPipelines.indexOf(name) > -1} />
            <ListItemText primary={name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
